import { useContext, useState } from "react";
import { useEffect } from "react";
import ApiRequest from "../Common/restservice";
import { companyColorsname, individualColorsname } from "../Common/showtoast";
import ThemeContext from "../themecontext";

export default function StockTree() {
  const { theme } = useContext(ThemeContext);
  const [topId, setTopId] = useState(localStorage.getItem("username"));
  const [topName, setTopName] = useState("");
  const [topStatus, settopStatus] = useState("");
  const [topRank, setTopRank] = useState("");
  const [topPackage, setTopPackage] = useState("");
  const [topJoindate, setTopJoindate] = useState("");
  const [downlines, setDownlines] = useState([]);
  const [navigates, setnavigates] = useState([]);
  useEffect(() => {
    ViewUserReferrals(topId);
  }, [topId]);
  const ViewUserReferrals = async (memberid) => {
    var json = await ApiRequest(
      "direct_sponsor_report.asp",
      "POST",
      {
        memberid: memberid,
      },
      {
        Authorization: localStorage.getItem("token"),
      }
    );
    if (json.status === "error") {
      setDownlines([]);
      return;
    }
    if (topId === localStorage.getItem("username")) {
      await MyProfile();
    }
    setDownlines(json.items);
  };
  const MyProfile = async (memberid) => {
    var json = await ApiRequest(
      "MyProfile.asp",
      "POST",
      {
        memberid: memberid,
      },
      {
        Authorization: localStorage.getItem("token"),
      }
    );
    if (json.status === "error") {
      setDownlines([]);
      return;
    }
    setTopName(json.fullname);
    setTopJoindate(json.joiningdate);
    settopStatus(json.activestatus === "True" ? "Active" : "Inactive");
    setTopRank(json.Rankname);
    setTopPackage(json.activestatus === "True" ? json.usertypecategory === "Company" ? "10000" : "20000" : "0");
  };
  return (
    <section className="content">
      <div className="row">
        <div className="col-xl-12 col-lg-12 col-md-12 col-xm-12">
          <div className="card overflow-hidden dash1-card border-0 ">
            <div className="card-body">
              <div className="container">
                <div className="input-group">
                  {navigates.length >= 1 && (
                    <span
                      className="btn btn-primary"
                      onClick={(e) => {
                        let id = navigates[navigates.length - 1];
                        if (id.memberid === localStorage.getItem("username")) {
                          setTopId(localStorage.getItem("username"));
                        } else {
                          setTopJoindate(id.joindate);
                          setTopName(id.fullname);
                          setTopId(id.memberid);
                          settopStatus(id.status);
                          setTopPackage(id.package);
                          setTopRank(id.rank);
                        }
                        setnavigates(navigates.filter((e1) => e1.memberid !== id.memberid));
                      }}
                    >
                      GoBack
                    </span>
                  )}
                  <span
                    className="btn btn-primary ml-auto ms-auto"
                    onClick={(e) => {
                      setTopId(localStorage.getItem("username"));
                    }}
                  >
                    Go To Top
                  </span>
                </div>
                <div className="card col-lg-2 mx-auto mt-5">
                  <div className="card-body text-center">
                    <p style={{ lineHeight: "24px" }}>
                      {" "}
                      <img
                        src={require("../Assets/Images/man.png")}
                        className="header-brand-img"
                        style={{ maxWidth: 50 }}
                        alt=""
                      />
                    </p>
                    <h4
                      className={`mt-3`}
                      style={{ color: topPackage === "10000" ? individualColorsname[topRank] : topPackage === "20000" ? companyColorsname[topRank] : theme === "dark" ? "white" : 'black' }}
                    >
                      {topName}
                    </h4>
                    {/* <h6
                      className={`fs-16`}
                      style={{color: topPackage === "10000" ? individualColorsname[topRank] : topPackage === "20000" ? companyColorsname[topRank] : theme === "dark" ? "white" : 'black'}}
                    >
                      {topId}
                    </h6> */}
                    {/* <h6>Join Date : {topJoindate}</h6>
                                    {topStatus && <h6>Status : {topStatus}</h6>} */}
                  </div>
                </div>
                <div className="d-flex" style={{ overflowX: "scroll" }}>
                  {downlines.map((e, i) => {
                    return (
                      <div
                        onClick={(eve) => {
                          console.log(e);
                          setnavigates([
                            ...navigates,
                            ...[
                              {
                                joindate: topJoindate,
                                fullname: topName,
                                memberid: topId,
                                status: topStatus,
                                rank: topRank,
                                package: topPackage
                              },
                            ],
                          ]);
                          setTopJoindate(e.joindate);
                          setTopName(e.fullname);
                          setTopId(e.memberid);
                          settopStatus(e.status);
                          setTopPackage(e.package);
                          setTopRank(e.rank);
                        }}
                        key={i}
                        className="card col-lg-2 mt-5"
                        style={{ cursor: "pointer", minWidth: 180 }}
                      >
                        <div className="card-body text-center">
                          <p style={{ lineHeight: "24px" }}>
                            {" "}
                            <img
                              src={require("../Assets/Images/man.png")}
                              className="header-brand-img"
                              style={{ maxWidth: 50 }}
                              alt=""
                            />
                          </p>
                          <h4
                            className={`mt-3`}
                            style={{ color: e.package === "10000" ? individualColorsname[e.rank] : e.package === "20000" ? companyColorsname[e.rank] : theme === "dark" ? "white" : 'black' }}
                          >
                            {e.fullname}
                          </h4>
                          {/* <h6
                            className={`fs-16 `}
                            style={{color: e.package === "10000" ? individualColorsname[e.rank] : e.package === "20000" ? companyColorsname[e.rank] : theme === "dark" ? "white" :'black'}}
                          >
                            {e.memberid}
                          </h6> */}
                          {/* <h6>Join Date : {e.joindate}</h6>
                                                <h6>Status : {e.status}</h6> */}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
